import api, { handleApiError, fetchAllDataRest } from './client';

export const courseService = {
  getCourses: async (params = {}) => {
    try {
      const queryParams = {
        search: params.search || undefined,
        academicYear: params.academicYear || undefined,
        page: params.page || 1,
        limit: params.limit || 20,
      };

      if (params.exportAll) {
        return await fetchAllDataRest('/api/courses', queryParams, 'corsi');
      }

      const response = await api.get('/api/courses', { params: queryParams });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get courses error:', error);
      return handleApiError(error, 'Errore nel caricamento dei corsi');
    }
  },

  getCourse: async (id) => {
    try {
      const response = await api.get(`/api/courses/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get course error:', error);
      return handleApiError(error, 'Errore nel caricamento del corso');
    }
  },

  createCourse: async (courseData) => {
    try {
      const payload = {
        name: courseData.name,
        academicYear: courseData.academicYear,
        description: courseData.description || null,
      };

      const response = await api.post('/api/courses', payload);
      return {
        success: true,
        data: response.data,
        message: 'Corso creato con successo',
      };
    } catch (error) {
      console.error('Create course error:', error);
      return handleApiError(error, 'Errore nella creazione del corso');
    }
  },

  updateCourse: async (id, courseData) => {
    try {
      const payload = {
        name: courseData.name,
        academicYear: courseData.academicYear,
        description: courseData.description || null,
      };

      const response = await api.put(`/api/courses/${id}`, payload);
      return {
        success: true,
        data: response.data,
        message: 'Corso aggiornato con successo',
      };
    } catch (error) {
      console.error('Update course error:', error);
      return handleApiError(error, "Errore nell'aggiornamento del corso");
    }
  },

  getCoursesSummary: async (search) => {
    try {
      const response = await api.get('/api/courses/summary', {
        params: { search: search || '' },
      });
      const items = response.data?.items || response.data || [];
      return { success: true, data: items };
    } catch (error) {
      console.error('Get courses summary error:', error);
      return handleApiError(error, 'Errore nel caricamento del riassunto dei corsi');
    }
  },

  deleteCourse: async (id) => {
    try {
      await api.delete(`/api/courses/${id}`);
      return { success: true, message: 'Corso eliminato con successo' };
    } catch (error) {
      console.error('Delete course error:', error);
      return handleApiError(error, "Errore nell'eliminazione del corso");
    }
  },

  getCourseEnrollmentStatistics: async (academicYear) => {
    try {
      const response = await api.get('/api/courses/enrollment-stats', {
        params: { academicYear },
      });
      return { success: true, data: response.data || [] };
    } catch (error) {
      console.error('Get course enrollment statistics error:', error);
      return handleApiError(error, 'Errore nel caricamento delle statistiche iscrizioni');
    }
  },
};

export default courseService;
